// extracted by mini-css-extract-plugin
export var closeButton = "_go-2";
export var closeButtonIcon = "_go-3";
export var lightboxContent = "_go-1";
export var lightboxOverlay = "_go-0";